import {
  FAILURE_FIELD_DATA,
  RECEIVE_FIELD_DETAILS,
  RECEIVE_FIELD_FEATURES,
  RECEIVE_COUNTRY_FEATURES,
} from '../constants/actionTypes';

export const initialState = {
  id: null,
  uuid: null,
  centroid: null,
  countryFeatures: [],
  fieldFeatures: [],
  error: undefined,
};

function fieldReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_FIELD_DETAILS: {
      const { id, uuid, centroid } = action.details;
      return {
        ...state,
        id,
        uuid,
        centroid,
      };
    }
    case RECEIVE_COUNTRY_FEATURES:
      return {
        ...state,
        countryFeatures: action.countryFeatures,
      };
    case RECEIVE_FIELD_FEATURES:
      return {
        ...state,
        fieldFeatures: action.fieldFeatures,
      };
    case FAILURE_FIELD_DATA:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export default fieldReducer;
